<template>
  <v-container fluid>
    <v-row>
      <v-col class="col-12">
        <h1>
          Dashboard
          <span class="float-right">
            <a class="text-orange" href="https://help.riggott-ims.co.uk/" target="_blank">
              <v-icon
                large
                color="orange">
                mdi-lifebuoy
              </v-icon>
              Help
            </a>
          </span>
        </h1>
      </v-col>
    </v-row>
    <Search />
    <v-row>
      <v-col>
        <router-link to="/admin/leave-requests-create">
          <v-btn>Request holiday</v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row v-if="userid === 115 || userid === 19">
      <v-col class="col-12">
        <LeaveRequests />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-4">
        <Sales />
      </v-col>
      <v-col class="col-12 col-md-8">
        <Directors
            v-if="userid === 4 ||userid === 107 || userid === 108 || userid === 111 || userid === 160 || userid === 113 || userid === 162 || userid === 165" />
      </v-col>
    </v-row>
    <span
      @click="updateInvoiceLines"
      style="margin-top:1500px; display:inline-block">
      ui {{ linesUpdated }}
    </span>
  </v-container>
</template>

<script>
import Directors from '@/components/Dashboard/Directors.vue';
import LeaveRequests from '@/components/Dashboard/LeaveRequests.vue';
import Localbase from "localbase";
import Sales from '@/components/Dashboard/Sales.vue';
import Search from '@/components/Dashboard/Search.vue';
import axios from '../axios';

export default {
  name: 'Start',
  data() {
    return {
      linesUpdated: 0,
    };
  },
  components: {
    Directors,
    LeaveRequests,
    Sales,
    Search,
  },
  computed: {
    userid() {
      return this.$store.state.userid;
    },
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    checkLoggedIn() {
      const db = new Localbase('db');
      db.config.debug = false;
      db.collection('users').get().then((users) => {
        if (users[0]) {
          console.log('Valid credentials');
        } else {
          this.$router.push('/');
        }
      });
    },
    updateInvoiceLines() {
      if (this.linesUpdated < 1000) {
        axios.get(`/invoices/updateInvoiceLines.json?token=${this.token}`)
          .then(() => {
            this.linesUpdated += 1;
            this.updateInvoiceLinesTwo();
          });
        }
    },
    updateInvoiceLinesTwo() {
      axios.get(`/invoices/updateInvoiceLines.json?token=${this.token}`)
        .then(() => {
          this.linesUpdated += 1;
          this.updateInvoiceLines();
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.checkLoggedIn();
    }, 500);
  },
};
</script>
